import { render, staticRenderFns } from "./AtendenceDetail.vue?vue&type=template&id=0ceb6437"
import script from "./AtendenceDetail.vue?vue&type=script&lang=js"
export * from "./AtendenceDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports